/**
 * @file components/UnderConstructionBanner.js
 * @description Slim amber banner shown on PUBLIC pages while Inspection Butler
 * is in alpha. Hidden from authenticated app pages.
 *
 * Visibility rules:
 *   - Only renders when REACT_APP_SHOW_DEV_BANNER === 'true'
 *   - Only renders for LOGGED-OUT users (auth.isAuthenticated === false)
 *
 * Patterned on components/OfflineIndicator.js (fixed top, high z-index).
 * z-index: 9998 (one below OfflineIndicator's 9999 — sync state wins).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function UnderConstructionBanner() {
  const auth = useAuth();

  // Gate 1: env flag must be on (the kill switch when we leave alpha)
  if (process.env.REACT_APP_SHOW_DEV_BANNER !== 'true') return null;

  // Gate 2 REMOVED (James, 2026-06-04): logged-in users ARE the alpha testers —
  // they need the "early days" notice most. The env flag remains the only gate.
  void auth;

  return (
    <div
      className="under-construction-banner"
      style={{
        // Normal flow (not fixed) so it sits ABOVE the sticky navbar instead
        // of covering it now that logged-in pages show both.
        position: 'relative',
        zIndex: 9998,
        padding: '0.5rem 1rem',
        textAlign: 'center',
        fontSize: '0.875rem',
        fontWeight: 600,
        fontFamily: 'var(--font-family, -apple-system, system-ui, sans-serif)',
        color: '#92400E',
        backgroundColor: '#FEF3C7',
        borderBottom: '1px solid #FDE68A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem',
      }}
      role="status"
      aria-live="polite"
    >
      <span role="img" aria-label="warning">⚠️</span>
      <span>
        The Butler Suite is in active alpha. Some features are still under construction.{' '}
        <Link to="/features" style={{ color: '#92400E', fontWeight: 700, textDecoration: 'underline' }}>
          What's shipped &rarr;
        </Link>
      </span>
    </div>
  );
}

export default UnderConstructionBanner;
